export default __webpack_public_path__ + "static/lab_banner-0772a1380a068f89d25a5c125c3c2352.jpg";